import React from 'react';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { FlowType, GroupItem } from '../../../../api/useEstatePlanningFlowQuery';
import { EdgeLoading } from '../Edge/Edge.loading';
import { NodesLoading } from '../Nodes/Nodes.loading';

interface Props {
  groupItems: GroupItem[];
}

export const GroupLoading = ({ groupItems }: Props) => {
  return (
    <Box display="flex">
      {groupItems.map((groupData, groupDataIndex) => {
        return (
          <React.Fragment key={groupDataIndex}>
            <Box
              display="flex"
              flexDirection="column"
              css={`
                min-width: 100%;
              `}
            >
              {groupData.items.map((item, flowDataItemsIndex) => {
                const isLast = flowDataItemsIndex + 1 === groupData.items.length;

                if (item.type === FlowType.Edge) {
                  return <EdgeLoading key={flowDataItemsIndex} />;
                }
                return <NodesLoading key={flowDataItemsIndex} items={item.items} isLast={isLast} />;
              })}
            </Box>
          </React.Fragment>
        );
      })}
    </Box>
  );
};
